// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__58VwD","cell":"ColumnAccessor_cell__TFWhB","firstCellAccent":"ColumnAccessor_firstCellAccent__2VeII"};